import { ReceiptIcon } from "@phosphor-icons/react/dist/csr/Receipt";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@volca/ui/components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { SUMP_PUMP } from "@volca/ui/components/ui/empty-machine";
import { EmptyPage } from "@volca/ui/components/ui/empty-page";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import { AP_TAB, apListPath } from "@/accounts-payable/utils/routes";
import { ForwardingEmptyState } from "./forwarding-empty-state";

const LAST_RUN_MS = 1200;

export const ReviewQueueEmpty = ({
  businessId,
  filtered,
  justCleared = false,
  onClearFilters,
  onBrowseInvoices,
}: {
  businessId: string | null;
  filtered: boolean;
  justCleared?: boolean;
  onClearFilters: () => void;
  onBrowseInvoices?: () => void;
}) => {
  const [pumping, setPumping] = useState(justCleared);
  useEffect(() => {
    if (!pumping) return;
    const timer = setTimeout(() => setPumping(false), LAST_RUN_MS);
    return () => clearTimeout(timer);
  }, [pumping]);

  return filtered ? (
    <Empty className={emptyStateVariants({ layout: "panel" })}>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <ReceiptIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>Nothing matches these filters</EmptyTitle>
        <EmptyDescription>
          Other invoices may still be waiting. Clear the filters to see the
          whole queue.
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button
          size="xs"
          variant="outline"
          className="mt-1"
          onClick={onClearFilters}
        >
          Clear filters
        </Button>
      </EmptyContent>
    </Empty>
  ) : (
    <ForwardingEmptyState
      businessId={businessId}
      onBrowseInvoices={onBrowseInvoices}
    >
      <EmptyPage
        art={SUMP_PUMP}
        active={pumping}
        title="All caught up"
        tagline="Nothing is waiting on you"
        action={
          onBrowseInvoices && (
            <Button variant="outline" onClick={onBrowseInvoices}>
              Browse all invoices
            </Button>
          )
        }
        footnote={
          <>
            Expecting an invoice that isn&apos;t here? Check the emails the
            agent read.{" "}
            <Button
              variant="link"
              className="h-auto p-0"
              render={<Link to={apListPath(AP_TAB.emails)} />}
              nativeButton={false}
            >
              Open emails
            </Button>
          </>
        }
      />
    </ForwardingEmptyState>
  );
};
